import { render, staticRenderFns } from "./Dailies.vue?vue&type=template&id=d2f81cd2&lang=pug"
import script from "./Dailies.vue?vue&type=script&lang=js"
export * from "./Dailies.vue?vue&type=script&lang=js"
import style0 from "./Dailies.vue?vue&type=style&index=0&id=d2f81cd2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports